import * as React from "react";
import { Form, Input, Checkbox, Select, InputNumber, DatePicker } from "antd";
import {
  SystemParametersInsertForm,
  SystemParametersConstants,
  InputNumberConstants,
  DateFormats
} from "../../../common/Constants";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";

const SystemParameterForm = ({
  getFieldDecorator,
  translate,
  rowData,
  getFieldValue
}: {
  getFieldDecorator;
  translate;
  rowData?: any;
  getFieldValue;
}) => {
  return (
    <Form>
      <Form.Item
        label={translate("system_parameters_form.path")}
        style={{ width: "100%" }}
      >
        {getFieldDecorator(SystemParametersInsertForm.Fields.PATH, {
          initialValue: rowData && rowData.path,
          rules: [
            {
              required: true,
              message: translate("system_parameters_form.required_message", {
                field: translate("system_parameters_form.path")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>

      <Form.Item
        label={translate("system_parameters_form.description")}
        style={{ width: "100%" }}
      >
        {getFieldDecorator(SystemParametersInsertForm.Fields.DESCRIPTION, {
          initialValue: rowData && rowData.description,
          rules: [
            {
              required: true,
              message: translate("system_parameters_form.required_message", {
                field: translate("system_parameters_form.description")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>

      <Form.Item label={translate("system_parameters_form.parameterType")}>
        {getFieldDecorator(SystemParametersInsertForm.Fields.PARAMETER_TYPE, {
          initialValue: rowData && rowData.parameterType,
          rules: [
            {
              required: true,
              message: translate("system_parameters_form.required_message", {
                field: translate("system_parameters_form.parameterType")
              })
            }
          ]
        })(
          <Select
            placeholder={translate(
              "system_parameters_form.select_parameter_type"
            )}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
          >
            <Select.Option key={SystemParametersConstants.VCHAR}>
              {translate("system_parameters_form.parameterTypes.VCHAR")}
            </Select.Option>
            <Select.Option key={SystemParametersConstants.NUMBER}>
              {translate("system_parameters_form.parameterTypes.NUMBER")}
            </Select.Option>
            <Select.Option key={SystemParametersConstants.INTEGER}>
              {translate("system_parameters_form.parameterTypes.INTEGER")}
            </Select.Option>

            <Select.Option key={SystemParametersConstants.DATE}>
              {translate("system_parameters_form.parameterTypes.DATE")}
            </Select.Option>

            <Select.Option key={SystemParametersConstants.CLOB}>
              {translate("system_parameters_form.parameterTypes.CLOB")}
            </Select.Option>

            <Select.Option key={SystemParametersConstants.BOOLEAN}>
              {translate("system_parameters_form.parameterTypes.BOOLEAN")}
            </Select.Option>
          </Select>
        )}
      </Form.Item>

      {getFieldValue(SystemParametersInsertForm.Fields.PARAMETER_TYPE) ===
        SystemParametersConstants.VCHAR && (
        <Form.Item
          label={translate("system_parameters_form.value_Vchar")}
          style={{ width: "100%" }}
        >
          {getFieldDecorator(SystemParametersInsertForm.Fields.VALUE_VCHAR, {
            initialValue: rowData && rowData.valueVchar,
            rules: [
              {
                required: true,
                message: translate("system_parameters_form.required_message", {
                  field: translate("system_parameters_form.valueVchar")
                })
              }
            ]
          })(<Input />)}
        </Form.Item>
      )}

      {getFieldValue(SystemParametersInsertForm.Fields.PARAMETER_TYPE) ===
        SystemParametersConstants.INTEGER && (
        <Form.Item
          label={translate("system_parameters_form.value_Integer")}
          style={{ width: "100%" }}
        >
          {getFieldDecorator(SystemParametersInsertForm.Fields.VALUE_INTEGER, {
            initialValue: rowData && rowData.valueInteger,
            rules: [
              {
                required: true,
                message: translate("system_parameters_form.required_message", {
                  field: translate("system_parameters_form.valueInteger")
                })
              }
            ]
          })(<InputNumber min={InputNumberConstants.MIN_VALUE} />)}
        </Form.Item>
      )}

      {getFieldValue(SystemParametersInsertForm.Fields.PARAMETER_TYPE) ===
        SystemParametersConstants.BOOLEAN && (
        <Form.Item
          label={translate("system_parameters_form.value_Boolean")}
          style={{ width: "100%" }}
        >
          {getFieldDecorator(SystemParametersInsertForm.Fields.VALUE_BOOLEAN, {
            valuePropName: "checked",
            initialValue: rowData ? rowData.valueBoolean : false,
            rules: [
              {
                required: true,
                message: translate("required_message.required_message", {
                  field: translate("required_message.value_Boolean")
                })
              }
            ]
          })(<Checkbox />)}
        </Form.Item>
      )}

      {getFieldValue(SystemParametersInsertForm.Fields.PARAMETER_TYPE) ===
        SystemParametersConstants.DATE && (
        <Form.Item
          label={translate("system_parameters_form.value_DateTime")}
          style={{ width: "100%" }}
        >
          {getFieldDecorator(SystemParametersInsertForm.Fields.VALUE_DATE, {
            initialValue:
              rowData && rowData.valueDateTime
                ? moment(rowData.valueDateTime, DateFormats.DATE)
                : undefined,
            rules: [
              {
                required: true,
                message: translate("system_parameters_form.required_message", {
                  field: translate("system_parameters_form.valueDateTime")
                })
              }
            ]
          })(
            <DatePicker
              placeholder={translate("system_parameters_form.select_date")}
              locale={{ dateFormat: DateFormats.DATE }}
              showToday={false}
            />
          )}
        </Form.Item>
      )}

      {getFieldValue(SystemParametersInsertForm.Fields.PARAMETER_TYPE) ===
        SystemParametersConstants.CLOB && (
        <Form.Item
          label={translate("system_parameters_form.value_Clob")}
          style={{ width: "100%" }}
        >
          {getFieldDecorator(SystemParametersInsertForm.Fields.VALUE_CLOB, {
            initialValue: rowData && rowData.valueClob,
            rules: [
              {
                required: true,
                message: translate("system_parameters_form.required_message", {
                  field: translate("system_parameters_form.valueClob")
                })
              }
            ]
          })(<TextArea autoSize={{ minRows: 3 }} />)}
        </Form.Item>
      )}

      {getFieldValue(SystemParametersInsertForm.Fields.PARAMETER_TYPE) ===
        SystemParametersConstants.NUMBER && (
        <Form.Item
          label={translate("system_parameters_form.value_Number")}
          style={{ width: "100%" }}
        >
          {getFieldDecorator(SystemParametersInsertForm.Fields.VALUE_NUMBER, {
            initialValue: rowData && rowData.valueNumber,
            rules: [
              {
                required: true,
                message: translate("system_parameters_form.required_message", {
                  field: translate("system_parameters_form.valueNumber")
                })
              }
            ]
          })(<InputNumber min={0} step={0.1} />)}
        </Form.Item>
      )}
    </Form>
  );
};

export default SystemParameterForm;
